/**
 * lastShowsChannelObservable.ts
 */
import { Observable } from 'rxjs';
import lastShowsChannel from './request';
const WAITING_TIME = 100;

/**
 * Observable that retrieves the last shows channel data.
 */
export default function lastShowsChannelObservable(
  channelCode: string,
  channelId: string
) {
  return new Observable((subscriber) => {
    lastShowsChannel(channelCode, channelId).then((data) => {
      setTimeout(() => {
        subscriber.next({ data });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
